import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import AddLink from '~components/generic/elements/add-link/AddLink';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { ModulesListPopover } from '~components/generic/module/ModulesListPopover/ModulesListPopover';
import { IEntityComponentProps } from '~interfaces/props';
import { convertToRawValue } from '~services/data-conversion';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import stripHtml from '~utils/stripHtml';

export default function ModuleLevel(props: IEntityComponentProps) {
  const { data, editing, onChange, onClick, onAddNewChild, origData, stable } = props;
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const childModuleIds = getRelatedEntityIds(data, 'field_modules');
  const childModuleIdsLength = childModuleIds.length - 1;
  const childLevelIds = getRelatedEntityIds(data, 'field_levels');
  const childLevelIdsLength = childModuleIds.length - 1;
  const classes = clsx({
    'c-level': true,
    'c-module': true,
    'o-container o-container--lg': true,
    'u-padding-vertical-md': props.activeId === origData,
  });
  const contentClasses = clsx({
    'c-level__content': true,
    'c-module__content': false,
    'u-margin-top-sm u-margin-bottom-lg': props.activeId === origData,
    'c-level__content--full': props.activeId === origData,
    'c-level__content--small': props.activeId !== origData,
  });
  const optionButtonClasses = clsx({
    'c-button': false,
    'u-margin-bottom-md': false,
    'u-block': false,
    'u-centered': false,
  });

  return (
    <div className={classes} id={getModuleUrlIdFromData(data.id, data.type)}>
      {props.activeId === origData ? (
        <div className="o-container o-container--lg relative">
          <div className={contentClasses}>
            <EditableField
              hide={content.field_hide_title}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={content.field_title.value}
              editing={editing}
              onChange={onChange}
            />
            <div className="c-level__modules">
              {editing && childModuleIds.length === 0 && (
                <div className="u-padding-bottom-xl container relative">
                  <ModulesListPopover type={data.type} parentContext={data.id} index={0} />
                </div>
              )}
              {childModuleIds &&
                childModuleIds.map((id, i) => {
                  return (
                    <div key={i} className="">
                      {editing && (
                        <div className="u-padding-bottom-xl container relative">
                          <ModulesListPopover type={data.type} parentContext={data.id} index={i} />
                        </div>
                      )}
                      <DraggableModuleContainer
                        parentIsStable={stable}
                        index={i}
                        key={id}
                        entityId={id}
                        parentContext={data.id}
                        parentType={data.type}
                        fieldName="relationships.field_modules.data"
                        siblingsLength={childModuleIdsLength}
                        canMove={editing}
                      />
                    </div>
                  );
                })}
            </div>
            <div className="c-level__level-options  o-grid o-grid--wrap">
              {editing && (
                <div className="o-grid__cell o-grid__cell--width-12">
                  <h5 className="u-padding-right-md">Levels: </h5>
                  <AddLink
                    onClick={() =>
                      onAddNewChild({
                        id: origData,
                        fieldName: 'relationships.field_levels.data',
                        templateType: 'paragraph--level',
                      })
                    }
                  />
                </div>
              )}
              {childLevelIds &&
                childLevelIds.map((id, i) => {
                  return (
                    <div key={i} className="o-container o-container--lg relative u-list">
                      <div className="c-radiobutton"> </div>
                      <DraggableModuleContainer
                        parentIsStable={stable}
                        index={i}
                        key={id}
                        entityId={id}
                        parentContext={data.id}
                        parentType={data.type}
                        fieldName="relationships.field_levels.data"
                        siblingsLength={childLevelIdsLength}
                        canMove={editing}
                        onClick={onClick}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      ) : (
        <div className={`${contentClasses} ${optionButtonClasses}`} onClick={() => onClick(origData)}>
          {content.field_title && content.field_title.value && stripHtml(convertToRawValue(content.field_title.value))}
        </div>
      )}
    </div>
  );
}
